<p-card class="dashBoard">
  <div class="allocation-report-dashboard-flex-container clear">
    <div class="allocation-report-dashboard-flex-child-left">
      <div class="title" style="width:auto"><span (click)="showAllocationReport()">Allocation Report</span></div>
      <span id="allocationReportToolTipIcon" class="infoIcon" calltoaction [calltoactionTemplate]="allocationReportToolTipIcon"></span>
    </div>
  </div>
  @if (!data) {
    <div class='loading-spinner'></div>
  }
  @if (data) {
    <div>
      <div class="section">
        <div class="chart-container">
          <p-chart type="doughnut" [data]="chartData" [options]="options" width="128px" height="70px"></p-chart>
          <div class="center chart-overlay">
            <div class="count">{{data.totalPortfolios}}</div>
            <div class="label">Portfolios</div>
          </div>
        </div>
      </div>
      <irb-panel-button [label]="'Out of Tolerance'" (click)="showAllocationReportWithOutOfTolerance()" [isTall]="true" [isDisabled]="data.outOfToleranceCount == 0"><span class="count irb-amber">{{data.outOfToleranceCount}}</span></irb-panel-button>
      <irb-panel-button [label]="'In Tolerance'" (click)="showAllocationReportWithInTolerance()" [isTall]="true" [isDisabled]="data.inToleranceCount == 0"><span class="count irb-green">{{data.inToleranceCount}}</span></irb-panel-button>
    </div>
  }
</p-card>
<ng-template #allocationReportToolTipIcon>
  <div>
    <p>Summary of portfolios that are Out of Tolerance and In Tolerance.</p>
    <p><strong>Out of Tolerance:</strong> At least one position in the portfolio is out of range relative to its model target.</p>
    <p> <strong>In Tolerance:</strong> All positions in the portfolio are within range relative to its model target.</p>
  </div>
</ng-template>
